import {B} from "../build";

export function isInHibernateAppMode(): boolean {
    return Boolean(B.HIBERNATE_APP);
}
